import { render } from "./PasswordInput.vue?vue&type=template&id=560cfeda&scoped=true"
import script from "./PasswordInput.vue?vue&type=script&lang=js"
export * from "./PasswordInput.vue?vue&type=script&lang=js"

import "./PasswordInput.vue?vue&type=style&index=0&id=560cfeda&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560cfeda"]])

export default __exports__